import { http, HttpResponse } from 'msw'

import { AdminCardApiModelStub } from '@webapp/modules/spending-cards/data-access/api-models/stubs/AdminCardApiModel.stub'
import { getResponseObject } from '@webapp/tests'

export const mockGetAdminCardSuccess = (
  externalId: string,
  cardStub = AdminCardApiModelStub.build()
) => {
  return http.get(
    `/api/v3/pay/admin/cards/${externalId}/`,
    () => {
      return HttpResponse.json(getResponseObject(cardStub), { status: 200 })
    },
    { once: true }
  )
}

export const mockGetAdminCardError = (externalId: string) => {
  return http.get(
    `/api/v3/pay/admin/cards/${externalId}/`,
    () => {
      return new HttpResponse(null, { status: 400 })
    },
    { once: true }
  )
}
